/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-border-align',
  templateUrl: './theme-option-elements-border-align.component.html',
  styleUrls: ['./theme-option-elements-border-align.component.css']
})
export class ThemeOptionElementsBorderAlignComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() serieIndex: number;

  showDetails: boolean;
  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_borderAlign';

  constructor() {
    this.showDetails = false;
  }

  onValue(value: string, type?: ChartType) {
    this.themeOptions.setSeries(this.optionType, value, this.serieIndex, type ? [type] : undefined);
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  values = {
    inner: { style: 'inner', label: 'INNER' },
    center: { style: 'center', label: 'CENTER' }
  };

}
